<template>
  <CRow>
    <CCol v-if="!this.$store.getters.isDispatcher">
      <CCard>
        <CCardHeader>
          COMPANY ADDRESS DETAILS
        </CCardHeader>
        <CCardBody>
          <div class="row">
            <div class="col-sm-4">
              <b-form-group>
                <label>Company Name</label>
                <div class="summary-field">{{ company.Name }}</div>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group>
                <label>Address</label>
                <div v-if="!addressEdit" class="summary-field">{{ company.Address1 }}</div>
                <div v-else>
                  <b-input placeholder="Address" v-model="company.Address1"
                           :class="{'is-invalid': $v.company.Address1.$error}"></b-input>
                  <b-form-invalid-feedback>Enter an address</b-form-invalid-feedback>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group>
                <label>Apartment, Suite, etc.</label>
                <div v-if="!addressEdit" class="summary-field">{{ company.Address2 }}</div>
                <div v-else>
                  <b-input placeholder="Apartment, suite, etc" v-model="company.Address2"></b-input>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <b-form-group>
                <label>City</label>
                <div v-if="!addressEdit" class="summary-field">{{ company.City }}</div>
                <div v-else>
                  <b-input placeholder="City" :class="{'is-invalid': $v.company.City.$error}"
                           v-model="company.City"></b-input>
                  <b-form-invalid-feedback>Enter a city</b-form-invalid-feedback>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group>
                <label>State</label>
                <div v-if="!addressEdit" class="summary-field">{{ company.StateCode }}</div>
                <div v-else>
                  <b-form-select v-model="company.StateCode" :class="{'is-invalid': $v.company.StateCode.$error}"
                                 :plain="true">
                    <option v-for="(state, i) in states" :value="state.value" :key="i">
                      {{ state.text }}
                    </option>
                  </b-form-select>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group>
                <label>Zip Code</label>
                <div v-if="!addressEdit" class="summary-field">{{ company.ZipCode }}</div>
                <div v-else>
                  <b-input placeholder="Zip code" :class="{'is-invalid': $v.company.ZipCode.$error}"
                           v-model="company.ZipCode"></b-input>
                  <b-form-invalid-feedback>Enter a zip code</b-form-invalid-feedback>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group>
                <label>Email Address For Invoice</label>
                <div v-if="!this.addressEdit" class="summary-field">{{ company.InvoiceEmail }}</div>
                <div v-else>
                  <CInput v-model="company.InvoiceEmail" :addInputClasses="{'is-invalid': $v.company.InvoiceEmail.$error}"
                          placeholder="Email"
                          autocomplete="email"
                          :invalid-feedback="getEmailInvalidMessage"/>
                </div>
              </b-form-group>
            </div>
            <div class="col">
            </div>
            <div class="col">
            </div>
          </div>
        </CCardBody>
        <CCardFooter>
          <b-button variant="primary" v-if="!addressEdit"
                    @click="addressEdit = !addressEdit"
                    class="mr-2">Edit
          </b-button>
          <template v-if="addressEdit">
            <b-button @click.prevent="saveAddressDetails"
                      variant="primary"
                      class="mr-2">Submit
            </b-button>
            <b-button @click="onCancel(true)" type="cancel" class="btn btn-secondary">
              Cancel
            </b-button>
          </template>
        </CCardFooter>
      </CCard>
    </CCol>
    <CCol>
      <CCard>
        <CCardHeader>
          USER DETAILS
        </CCardHeader>
        <CCardBody>
          <div class="row">
            <div class="col">
              <b-form-group>
                <label>Full Name</label>
                <div v-if="!this.detailEdit" class="summary-field">{{ user.Name }}</div>
                <div v-else>
                  <b-input placeholder="Company name" v-model="user.Name"
                           :class="{'is-invalid': $v.user.Name.$error}"></b-input>
                  <b-form-invalid-feedback>Enter full name</b-form-invalid-feedback>
                </div>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>Mobile Phone</label>
                <div v-if="!this.detailEdit" class="summary-field">{{ user.Phone }}</div>
                <div v-else>
                  <CInput type="tel" maxlength="14" v-model="user.Phone" @input="acceptNumber"
                          :addInputClasses="{'is-invalid': $v.user.Phone.$error}"
                          placeholder="(123) 345-6789"
                          :invalid-feedback="getPhoneInvalidMessage">
                    <template #prepend-content>
                      <CIcon name="cil-phone"/>
                    </template>
                  </CInput>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group>
                <label>Email Address</label>
                <div class="summary-field">{{ user.Email }}</div>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group>
                <label>Password</label>
                <div v-if="!this.detailEdit" class="summary-field">*************************************</div>
                <div v-else>
                  <CInput v-model="user.Password" :addInputClasses="{'is-invalid': $v.user.Password.$error}"
                          placeholder="Password"
                          type="password"
                          autocomplete="new-password"
                          :invalid-feedback="getPasswordInvalidMessage">
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                </div>
              </b-form-group>
            </div>
          </div>
        </CCardBody>
        <CCardFooter>
          <b-button variant="primary" v-if="!detailEdit"
                    @click="detailEdit = !detailEdit"
                    class="mr-2">Edit
          </b-button>
          <template v-if="detailEdit">
            <b-button @click.prevent="saveCompanyDetails"
                      variant="primary"
                      class="mr-2">Submit
            </b-button>
            <b-button @click="onCancel(false)" type="cancel" class="btn btn-secondary">
              Cancel
            </b-button>
          </template>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { STATES } from '../../components/helper/states'
export default {
  name: 'Profile',
  data () {
    return {
      states: STATES,
      detailEdit: false,
      addressEdit: false,
      company: {},
      user: {
        ID: null,
        Name: '',
        Phone: ''
      }
    }
  },
  created () {
    this.loadUser()
    this.loadCompany()
  },
  methods: {
    onCancel (isAddress) {
      if (isAddress) {
        this.addressEdit = !this.addressEdit
        this.loadCompany()
      } else {
        this.detailEdit = !this.detailEdit
        this.loadUser()
      }
    },
    loadUser () {
      this.axios.get('api/user')
        .then(response => {
          this.user = response.data.user
          this.$loading.hide()
        })
        .catch(error => {
          this.$loading.hide()
          this.$toastr.error(error.response.data.message)
        })
    },
    loadCompany () {
      this.axios.get('api/company')
        .then(response => {
          this.company = response.data.company
          this.$loading.hide()
        })
        .catch(error => {
          this.$loading.hide()
          this.$toastr.error(error.response.data.message)
        })
    },
    saveCompanyDetails (event) {
      event.preventDefault()
      this.user.Phone = this.user.Phone.replace(/\D/g, '')
      if (this.$v.user.$invalid) {
        this.$v.$touch()
        return
      }
      this.$loading.show()
      this.axios.post('api/save-user-details', this.user)
        .then(response => {
          this.$loading.hide()
          if (response.status === 200) {
            this.$toastr.success('Successfully updated!')
            this.detailEdit = false
          } else {
            this.$toastr.error(response.data.message)
          }
          this.loadUser()
        }).catch((error) => {
          if (error.response && error.response.data.message) {
            this.$toastr.error(error.response.data.message)
          }
          this.$loading.hide()
        })
    },
    saveAddressDetails (event) {
      event.preventDefault()
      if (!this.isValidZipCode(this.company.ZipCode)) {
        this.$toastr.error('Enter a valid zip code')
        return
      }
      if (this.$v.company.$invalid) {
        this.$v.$touch()
        return
      }
      this.$loading.show()
      this.axios.post('api/save-address-details', this.company)
        .then(response => {
          this.$loading.hide()
          if (response.status === 200) {
            this.$toastr.success('Successfully updated!')
            this.addressEdit = false
          } else {
            this.$toastr.error(response.data.message)
          }
          this.loadCompany()
        }).catch((error) => {
          if (error.response && error.response.data.message) {
            this.$toastr.error(error.response.data.message)
          }
          this.$loading.hide()
        })
    },
    acceptNumber (value) {
      const x = value
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      this.user.Phone = value
    },
    isValidZipCode (value) {
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)
    }
  },
  computed: {
    getEmailInvalidMessage: function () {
      if (this.company.InvoiceEmail && !this.$v.company.InvoiceEmail.email) {
        return 'Enter a valid email address'
      } else {
        return 'Enter your email'
      }
    },
    getPhoneInvalidMessage: function () {
      if (this.user.Phone && !this.$v.user.Phone.length) {
        return 'Enter a valid phone number'
      }
      return 'Enter a phone number'
    },
    getPasswordInvalidMessage: function () {
      if (this.user.Password && !this.$v.user.Password.minLength) {
        return 'Password must be minimum 6 characters'
      } else {
        return 'Enter a password'
      }
    }
  },
  validations: {
    company: {
      Address1: {
        required
      },
      City: {
        required
      },
      StateCode: {
        required
      },
      ZipCode: {
        required
      },
      InvoiceEmail: {
        email
      }
    },
    user: {
      Name: {
        required
      },
      Phone: {
        required, minLength: minLength(10)
      },
      Email: {
        required, email
      },
      Password: {
        minLength: minLength(6)
      }
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>
